import React from "react";
import { SubsectionWithCheckboxes } from "./subsection/checkboxes";
import { SearchCommonField } from "../inputs/common-field";

export const BeachSection = () => {
    return (
        <>
            <SubsectionWithCheckboxes
                label="What types of beaches do you prefer?"
                name="beachType"
            >
                <SearchCommonField name="beach.sand" />
                <SearchCommonField name="beach.pebble" />
                <SearchCommonField name="beach.rocky" />
            </SubsectionWithCheckboxes>
            <SubsectionWithCheckboxes
                label="What sports do you wanna do?"
                name="beachSports"
            >
                <SearchCommonField name="beachSports.snorkelling" />
                <SearchCommonField name="beachSports.surfing" />
                <SearchCommonField name="beachSports.scubaDiving" />
                <SearchCommonField name="beachSports.windsurfing" />
                <SearchCommonField name="beachSports.kitesurfing" />
                <SearchCommonField name="beachSports.fishing" />
                <SearchCommonField name="beachSports.paddleboarding" />
                <SearchCommonField name="beachSports.sailing" />
            </SubsectionWithCheckboxes>
            <SubsectionWithCheckboxes
                label="What features should your ideal beach have?"
                noMarginBottom
                name="beachAmenities"
            >
                <SearchCommonField name="beach.tropical" />
                <SearchCommonField name="beach.turquise" />
                <SearchCommonField name="beach.picturesque" />
                <SearchCommonField name="beach.mountainViews" />
                <SearchCommonField name="beach.kiosks" />
                <SearchCommonField name="beach.sunbeds" />
                <SearchCommonField name="beach.secluded" />
                <SearchCommonField name="beach.palms" />
                <SearchCommonField name="beach.accessible" />
            </SubsectionWithCheckboxes>
        </>
    );
};
